import { defineStore } from 'pinia';

export const usePlanningGroupStore = defineStore('planningGroup', {
  state: () => ({
    id: null as string | null,
    name: null as string | null,
  }),
});
